import ModalCancelPendingDispatch from './ModalCancelPendingDispatch'

export default ModalCancelPendingDispatch
